import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Book = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 24 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M11.8333 5.33333V20.5M11.8333 5.33333C11.8333 4.18406 11.3768 3.08186 10.5641 2.2692C9.75147 1.45655 8.64927 1 7.5 1H2.08333C1.79602 1 1.52047 1.11414 1.3173 1.3173C1.11414 1.52047 1 1.79602 1 2.08333V16.1667C1 16.454 1.11414 16.7295 1.3173 16.9327C1.52047 17.1359 1.79602 17.25 2.08333 17.25H8.58333C9.44529 17.25 10.2719 17.5924 10.8814 18.2019C11.4909 18.8114 11.8333 19.638 11.8333 20.5M11.8333 5.33333C11.8333 4.18406 12.2899 3.08186 13.1025 2.2692C13.9152 1.45655 15.0174 1 16.1667 1H21.5833C21.8706 1 22.1462 1.11414 22.3494 1.3173C22.5525 1.52047 22.6667 1.79602 22.6667 2.08333V16.1667C22.6667 16.454 22.5525 16.7295 22.3494 16.9327C22.1462 17.1359 21.8706 17.25 21.5833 17.25H15.0833C14.2214 17.25 13.3947 17.5924 12.7852 18.2019C12.1757 18.8114 11.8333 19.638 11.8333 20.5'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Book;
